import axios, { AxiosRequestConfig } from 'axios';
import { cookies } from '../store/apis'

const instance = axios.create();
export const BASE_URL = process.env.REACT_APP_BASE_API_URL;
instance.interceptors.request.use((config: AxiosRequestConfig) => {
  return {
    ...config,
    url: `${BASE_URL}${config.url}`,
    withCredentials: true,
    headers: {
      'authorization-token': cookies.load('authToken'),
			'authorization': process.env.REACT_APP_AUTHORIZATION_HEADER,
    },
  };
});

export default instance;
